(function() {

    'use strict';

    angular.module('app').
    controller('NonManifestedShipmentsByCarrier', NonManifestedShipmentsByCarrier);

    NonManifestedShipmentsByCarrier.$inject = ['$scope', 'Carrier', 'NonManifestedByCarrierTableService'];

    function NonManifestedShipmentsByCarrier($scope, Carrier, NonManifestedByCarrierTableService) {

        var vm = this;

        init();

        function init() {
            vm.nonManifestedShipments = NonManifestedByCarrierTableService;
        };
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/manifests/NonManifestedShipmentsByCarrier.js